import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Button, Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import { PhoneNumberClient } from '../../api/server';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { ExtendedClient } from '../../api/ExtendedClient';

const Item = styled('div')({
    color: 'darkslategray',
});

const PhoneNumbers = () => {
    const [phoneNumbers, setPhoneNumbers] = React.useState([])
    const globalInfo = useSelector((state) => state.globalInfo)
    const [showButton, setShowButton] = React.useState(false);

    function reload() {
        const client = (new ExtendedClient(PhoneNumberClient)).getClient();

        client.getPhoneNumbers(globalInfo.currentCompanyId).then((data) => {
            setPhoneNumbers(data);
            // console.log(data)
        })
    }

    function followupActionName(action) {

        if (!action) return "";


        var x = JSON.parse(action);

        //console.log(x);

        if (x.followUpAction && x.followUpAction.name) {
            return x.followUpAction.name;
        }
        else {
            return ""
        }

    }


    React.useEffect(() => {
        reload();

        // eslint-disable-next-line
    }, [globalInfo])


    React.useEffect(() => {
        const handleKeyDown = (event) => {
          if (event.ctrlKey && event.shiftKey && event.key === "X") {
            console.log(showButton)
            setShowButton((prevShowButton) => !prevShowButton)
            console.log(!showButton)
          }
        };
    
        window.addEventListener("keydown", handleKeyDown);
    
        // Cleanup event listener on component unmount
        return () => {
          window.removeEventListener("keydown", handleKeyDown);
        };

        // eslint-disable-next-line
      }, [showButton]);


    return (
        <div>


            <h2>My Phone Numbers</h2>

            <TableContainer component={Paper}>
                <Table>

                    <TableBody>
                        {phoneNumbers.map((row) => (
                            <TableRow
                                key={row.phoneNumberId}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >

                                <TableCell>
                                    <Grid container spacing={2} >
                                        <Grid container item xs={12} md={6}>
                                            <Grid item xs={12} lg={12}>
                                                <Item>
                                                    When <strong> {row.phoneNumberDigits.getFormattedPhoneNum()} </strong> is called 
                                                    <br />&nbsp;&nbsp;<strong>Play Holiday Greeting (if any) </strong>Followed by
                                                    <br />&nbsp;&nbsp;<strong>Play Daily Greeting (if any) </strong>Followed by
                                                    <br />&nbsp;
                                                <strong> {JSON.parse(row.action).name}</strong> 
                                                    {
                                                        followupActionName(row.action) && <>
                                                            <>
                                                                &nbsp;Followed by
                                                            </>
                                                            <>
                                                               <br />&nbsp;<strong> {followupActionName(row.action)}</strong>
                                                            </>
                                                        </>
                                                    }
                                                </Item>

                                            </Grid>

                                        </Grid>
                                        <Grid item>
                                            <Item>
                                                <Button variant='contained' component={Link} to={`/editphonenumber/${row.phoneNumberId}`}>Settings</Button> &nbsp; &nbsp;
                                                    <Button variant='contained' component={Link} to={`/businesshours/${row.phoneNumberId}`}>Business Hours</Button> &nbsp; &nbsp;
                                                    <Button variant='contained' component={Link} to={`/holidays/${row.phoneNumberId}`}>Holiday Greeting</Button> &nbsp; &nbsp;
                                            </Item>
                                            <Item>  
                                                <br></br>
                                                <Button variant='contained' component={Link} to={`/businesshours/${row.phoneNumberId}`}>Daily Greeting</Button> &nbsp; &nbsp;
                                                {showButton && <Button variant='contained' component={Link} to={`/phonebook/${row.phoneNumberId}`}>Phone Book</Button> }&nbsp; &nbsp;
                                                {<Button variant='contained' component={Link} to={`/prioritylist/${row.phoneNumberId}`}>Call Special Handling</Button> }&nbsp; &nbsp;
                                            </Item>
                                        </Grid>

                                    </Grid>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

        </div>

    )
}

export default PhoneNumbers